import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FeaturesSection } from './components/FeaturesSection';
import { DemoSection } from './components/DemoSection';
import { PricingSection } from './components/PricingSection';
import { TrustSection } from './components/TrustSection';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <div className="min-h-screen bg-white text-gray-900 font-sans" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProofSection data-id="element-4" />
        <FeaturesSection data-id="element-5" />
        <DemoSection data-id="element-6" />
        <PricingSection data-id="element-7" />
        <TrustSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
      <FloatingCTA data-id="element-10" />
    </div>;
}